export default __webpack_public_path__ + "static/media/Ingemax.a89ac1bc.png";